<div class="application-generation">
  <h2>{{'customerWizard.appGenerationTitle' | translate}}</h2>

  <div class="form">
    <mat-form-field class="select">
      <mat-label>{{'customerWizard.appType' | translate}}</mat-label>
      <mat-select [(ngModel)]="app.type">
        <mat-option *ngFor="let type of possibleAppTypes" [value]="type">{{'customerWizard.appTypes.' + type | translate}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="app.type === 'dynamicContent'">
      <mat-form-field>
        <mat-label>{{'general.title' | translate}}</mat-label>
        <input [(ngModel)]="app.title" matInput>
      </mat-form-field>

      <mat-form-field class="select">
        <mat-label>{{'customerWizard.appSubType' | translate}}</mat-label>
        <mat-select [(ngModel)]="app.subType">
          <mat-option (click)="app.title = app.title || type.title" *ngFor="let type of dynamicContentTypes" [value]="type.value">{{type.title}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field class="select" *ngIf="app.type === 'special'">
      <mat-label>{{'customerWizard.appSubType' | translate}}</mat-label>
      <mat-select [(ngModel)]="app.subType">
        <mat-option (click)="app.title = type.title" *ngFor="let type of specialAppTypes" [value]="type.value">{{type.title}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="app.type === 'import'">
      <div class="first-row">
        <mat-form-field>
          <mat-label>{{'general.title' | translate}}</mat-label>
          <input [(ngModel)]="app.title" matInput>
        </mat-form-field>
        <mat-slide-toggle [(ngModel)]="app.languageSpecific" color="primary">{{'customerWizard.languageSpecific' | translate}}</mat-slide-toggle>
      </div>
      <mat-tab-group *ngIf="app.languageSpecific" [selectedIndex]="selectedIndex">
        <mat-tab *ngFor="let lang of data.languages" label="{{lang}}">
          <data-table (custom)="onCustomImportType($event)" *ngIf="!app.subType" [columns]="importColumns"
                      [dataProvider]="importTypeService"
                      icon="done" title="{{'customerWizard.importType' | translate}}"></data-table>
          <h3 *ngIf="app.subType">
            {{'customerWizard.importType' | translate}}: {{app.subTypeTitle}}
            <button (click)="app.subType = null; app.subTypeTitle = null" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </h3>
          <h4 *ngFor="let importElement of app.importsByLanguage[lang]; let i = index">
            <span>{{importElement.title}}</span>
            <button (click)="app.imports.splice(i, 1)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </h4>
          <data-table (custom)="assignImport($event, lang)" *ngIf="app.subType" [columns]="importColumns"
                      [dataProviderParams]="{ typeId: app.subType }" [dataProvider]="importService"
                      icon="done" title="{{'customerWizard.import' | translate}}"></data-table>
        </mat-tab>
      </mat-tab-group>
      <ng-container *ngIf="!app.languageSpecific">
        <data-table (custom)="onCustomImportType($event)" *ngIf="!app.subType" [columns]="importColumns"
                    [dataProvider]="importTypeService" icon="done" title="{{'customerWizard.importType' | translate}}"></data-table>
        <h3 *ngIf="app.subType">
          {{'customerWizard.importType' | translate}}: {{app.subTypeTitle}}
          <button (click)="app.subType = null; app.subTypeTitle = null" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </h3>
        <h4 *ngFor="let importElement of app.imports; let i = index">
          <span>{{importElement.title}}</span>
          <button (click)="app.imports.splice(i, 1)" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </h4>
        <div *ngIf="getAvailableImport()">
          <span>{{'customerWizard.newImport' | translate}}</span>
          <mat-form-field>
            <mat-label>{{'general.title' | translate}}</mat-label>
            <input [(ngModel)]="newImport.title" matInput>
          </mat-form-field>
          <ng-container *ngIf="getAvailableImport().type === 'publicTransport'">
            <div *ngIf="newImport.stop">
              {{newImport.stop.name}}
            </div>
            <div *ngIf="!newImport.stop">
              <mat-form-field>
                <input #state="ngModel" (ngModelChange)="searchStop()" [(ngModel)]="currentSearchTerm" [matAutocomplete]="tdAuto" matInput
                       name="state" placeholder="Find stop">
              </mat-form-field>
              <mat-autocomplete #tdAuto="matAutocomplete" (optionSelected)="selectStop($event)">
                <mat-option *ngFor="let stop of stops" [value]="stop.stopId">
                  <span>{{stop.name}}</span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </ng-container>
        </div>
        <data-table (custom)="assignImport($event)" *ngIf="app.subType" [columns]="importColumns" [dataProvider]="importService"
                    [dataProviderParams]="{ typeId: app.subType }" icon="done" title="{{'customerWizard.import' | translate}}"></data-table>
      </ng-container>
    </div>
  </div>

  <div *ngIf="error" class="error">{{error}}</div>

  <div class="button-right-container">
    <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{'general.cancel' | translate}}</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</div>
